import { useState } from 'react';
import { useSession } from '../../context/session-context';
import { useWorkspace } from '../../context/workspace-context';
import { useNavigate } from 'react-router-dom';
import { WORKSPACE_STORAGE_KEY } from '../../constants/workspace';
import supabase from '../../supabase';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Building2 } from 'lucide-react';
import { useTier } from '../../hooks/use-tier';
import UpgradePopup from '../upgrade-popup';

const Header = () => {
  const { session } = useSession();
  const navigate = useNavigate();
  const {
    currentWorkspace,
    availableWorkspaces,
    switchWorkspace,
    canSwitchWorkspaces,
  } = useWorkspace();
  const { limits } = useTier();
  const [showUpgrade, setShowUpgrade] = useState(false);
  const canUpgrade = limits?.canUpgrade ?? false;

  const handleSignOut = async () => {
    localStorage.removeItem(WORKSPACE_STORAGE_KEY);
    await supabase.auth.signOut();
    navigate('/sign-in');
  };

  return (
    <header className="bg-white border-b border-gray-200 py-4 fixed top-0 left-0 right-0 z-10 h-16">
      <div className="mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center gap-4">
          <img
            src="/images/llaami-logo.svg"
            alt="Llaami"
            width={150}
            height={150}
          />

          {/* Workspace Switcher - Only for Super Admins */}
          {canSwitchWorkspaces && availableWorkspaces.length > 1 && (
            <div className="ml-8">
              <Select
                value={currentWorkspace?.id.toString()}
                onValueChange={(value) => switchWorkspace(parseInt(value))}
              >
                <SelectTrigger className="w-[220px]">
                  <div className="flex items-center gap-2">
                    <Building2 className="h-4 w-4 text-gray-500" />
                    <SelectValue>
                      {currentWorkspace?.name || 'Select workspace'}
                    </SelectValue>
                  </div>
                </SelectTrigger>
                <SelectContent>
                  {availableWorkspaces.map((workspace) => (
                    <SelectItem
                      key={workspace.id}
                      value={workspace.id.toString()}
                    >
                      {workspace.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>

        <div className="flex items-center gap-4">
          {canUpgrade && (
            <button
              type="button"
              onClick={() => setShowUpgrade(true)}
              className="text-sm text-accent-purple hover:text-accent-purple/80 transition-colors"
            >
              Upgrade
            </button>
          )}
          <span className="text-gray-600">
            {session?.user?.user_metadata?.name}{' '}
            {session?.user?.user_metadata?.surname}
          </span>
          <button
            onClick={handleSignOut}
            className="text-sm px-4 py-2 rounded-xl bg-accent-purple text-white hover:bg-accent-purple/90"
          >
            Sign Out
          </button>
        </div>
      </div>
      <UpgradePopup open={showUpgrade} onOpenChange={setShowUpgrade} />
    </header>
  );
};

export default Header;
